import { useAsyncModal } from '@/libs/antd/components/Modal';
import { FC } from 'react';
import ManualSLIKInputModal from './ManualSLIKInputModal';

export const useViewSLIKModal = () =>
	useAsyncModal<
		{
			customerId: string;
			mppId: number;
			mppSlikInquiryId: number;
		},
		void
	>();

export type ViewSLIKModalProps = ReturnType<typeof useViewSLIKModal>;

const ViewSLIKModal: FC<ViewSLIKModalProps> = ({ modal, close, data }) => {
	if (!data) return null;

	return (
		<ManualSLIKInputModal
			modal={modal}
			close={close}
			data={{
				customerId: data.customerId,
				mppSlikInquiryId: data.mppSlikInquiryId,
			}}
			viewOnly={true}
		/>
	);
};

export default ViewSLIKModal;
